import { FirebaseAuth } from '../../../../lib/firebase'
import { isDesktopApp } from './helpers'
import { facebookProvider } from './providers'

export const facebookSignIn = (): Promise<any> => {
  return isDesktopApp
    ? FirebaseAuth.signInWithRedirect(facebookProvider)
    : FirebaseAuth.signInWithPopup(facebookProvider)
}
